export default "__VITE_ASSET__CROnZLBD__"